import type { SVGProps } from 'react';

export function GradientEllipse(props: SVGProps<SVGSVGElement>) {
    return (
        <svg viewBox="0 0 2898 2940" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <g opacity="0.6" filter="url(#filter0_f_1818_3025)">
                <ellipse
                    cx="481.954"
                    cy="1313.64"
                    rx="481.954"
                    ry="1313.64"
                    transform="matrix(0.629042 -0.777371 0.629042 0.777371 266.338 822.59)"
                    fill="#FDA599"
                />
            </g>
            <g opacity="0.15" filter="url(#filter1_f_1818_3025)">
                <path
                    d="M1867.73 1324.34C2272.87 1729.48 2469.21 2190.02 2306.26 2352.97C2143.3 2515.92 1682.77 2319.58 1277.63 1914.44C872.486 1509.3 676.151 1048.76 839.102 885.813C1002.05 722.862 1462.59 919.197 1867.73 1324.34Z"
                    fill="#EB756E"
                />
            </g>
            <g opacity="0.5" filter="url(#filter2_f_1818_3025)">
                <ellipse
                    cx="456.029"
                    cy="1282.21"
                    rx="456.029"
                    ry="1282.21"
                    transform="matrix(0.629042 -0.777371 0.629042 0.777371 414.982 880.356)"
                    fill="#B0C7ED"
                />
            </g>
            <g opacity="0.3" filter="url(#filter3_f_1818_3025)">
                <ellipse
                    cx="1513.4"
                    cy="1383.44"
                    rx="422.97"
                    ry="1050.45"
                    transform="rotate(-45 1513.4 1383.44)"
                    fill="#889CB9"
                />
            </g>
            <g opacity="0.2" filter="url(#filter4_f_1818_3025)">
                <ellipse
                    cx="1442.91"
                    cy="1177.12"
                    rx="422.97"
                    ry="1050.45"
                    transform="rotate(-45 1442.91 1177.12)"
                    fill="#B0C7ED"
                />
            </g>
            <g filter="url(#filter5_f_1818_3025)">
                <ellipse
                    cx="490.085"
                    cy="1016.75"
                    rx="490.085"
                    ry="1016.75"
                    transform="matrix(0.999148 0.0412693 0.583217 0.812316 449.043 624.463)"
                    className="fill-white dark:fill-[var(--color-background-main)]"
                />
            </g>
            <defs>
                <filter
                    id="filter0_f_1818_3025"
                    x="327.908"
                    y="193.579"
                    width="2135.87"
                    height="2551.08"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="93.75"
                        result="effect1_foregroundBlur_1818_3025"
                    />
                </filter>
                <filter
                    id="filter1_f_1818_3025"
                    x="725.529"
                    y="772.241"
                    width="1694.3"
                    height="1694.3"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="28.125"
                        result="effect1_foregroundBlur_1818_3025"
                    />
                </filter>
                <filter
                    id="filter2_f_1818_3025"
                    x="502.117"
                    y="314.399"
                    width="2012.58"
                    height="2416.42"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur stdDeviation="75" result="effect1_foregroundBlur_1818_3025" />
                </filter>
                <filter
                    id="filter3_f_1818_3025"
                    x="336.852"
                    y="206.89"
                    width="2353.1"
                    height="2353.1"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="187.801"
                        result="effect1_foregroundBlur_1818_3025"
                    />
                </filter>
                <filter
                    id="filter4_f_1818_3025"
                    x="266.356"
                    y="0.57309"
                    width="2353.1"
                    height="2353.1"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="187.801"
                        result="effect1_foregroundBlur_1818_3025"
                    />
                </filter>
                <filter
                    id="filter5_f_1818_3025"
                    x="603.941"
                    y="485.73"
                    width="1855.51"
                    height="1969.77"
                    filterUnits="userSpaceOnUse"
                    colorInterpolationFilters="sRGB"
                >
                    <feFlood floodOpacity="0" result="BackgroundImageFix" />
                    <feBlend
                        mode="normal"
                        in="SourceGraphic"
                        in2="BackgroundImageFix"
                        result="shape"
                    />
                    <feGaussianBlur
                        stdDeviation="79.3527"
                        result="effect1_foregroundBlur_1818_3025"
                    />
                </filter>
            </defs>
        </svg>
    );
}
